import { render, staticRenderFns } from "./VesselsIndex.vue?vue&type=template&id=f249ea50&"
import script from "./VesselsIndex.vue?vue&type=script&lang=js&"
export * from "./VesselsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports